import React from 'react'
import { fileUrl } from '../../functions/fileUrl'
import RichText from '../../../lib/components/RichText'

// Freitext-Abschnitt (Messeplan, Kontakt, Aussteller werden): Text und Bild
// gehören der Kachel — jeder Abschnitt trägt seinen eigenen Text (Spec 4.2).
const StaticSection = ({ tile }) => (
    <div className="section-static">
        {tile.image && <img className="section-static-image" src={fileUrl(tile.image.fileId)} alt={tile.title} />}
        {tile.text && <RichText html={tile.text} />}
    </div>
)

export default StaticSection
